
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 308.99 308.99"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M301.135 82.438L159.869 19.441a13.147 13.147 0 00-10.767 0L7.843 82.438A13.222 13.222 0 00.016 94.061c-.165 5.041 2.534 9.751 6.993 12.123l141.257 75.333a13.134 13.134 0 006.224 1.556c2.152 0 4.284-.511 6.235-1.556l141.264-75.333c4.455-2.372 7.157-7.082 6.995-12.123-.193-5.051-3.231-9.57-7.849-11.623z"}}),_c('path',{attrs:{"d":"M289.527 138.805l-135.045 72.04-135.023-72.04c-6.464-3.449-14.468-1.002-17.894 5.45-3.45 6.449-1.003 14.451 5.443 17.891L148.265 237.5a13.215 13.215 0 006.224 1.555c2.152 0 4.284-.51 6.235-1.555l141.264-75.354c6.431-3.44 8.875-11.442 5.445-17.891-3.452-6.453-11.462-8.9-17.906-5.45z"}}),_c('path',{attrs:{"d":"M289.527 190.476l-135.045 72.016-135.023-72.016c-6.464-3.452-14.468-1.002-17.894 5.441-3.45 6.449-1.003 14.459 5.443 17.894l141.257 75.33a13.14 13.14 0 006.224 1.562c2.152 0 4.284-.51 6.235-1.562l141.264-75.33c6.431-3.435 8.875-11.444 5.445-17.894-3.452-6.443-11.451-8.894-17.906-5.441z"}})])
          )
        }
      }
    